export const Actions = {
    // Fetch Deals
    FETCH_DEALS_REQUEST: 'FETCH_USER_DEALS_REQUEST',
    FETCH_DEALS_SUCCESS: 'FETCH_USER_DEALS_SUCCESS',
    FETCH_DEALS_FAILURE: 'FETCH_USER_DEALS_FAILURE',
    DEALS_FETCHED: 'DEALS_USER_FETCHED',

    // Update Deal
    UPDATE_DEAL: 'UPDATE_DEAL',
    UPDATE_DEALREFID: 'UPDATE_DEALREFID',
    UPDATE_ACTIVE_DEAL_FROM_PARTICIPANTS_SAVE: 'UPDATE_ACTIVE_DEAL_FROM_PARTICIPANTS_SAVE',
    UPDATE_DEAL_REQUEST: 'UPDATE_DEAL_REQUEST',
    UPDATE_DEAL_SUCCESS: 'UPDATE_DEAL_SUCCESS',
    UPDATE_DEAL_FAILURE: 'UPDATE_DEAL_FAILURE',

    // Fetch Dealer Details base in dnaAccountId
    DEALER_DETAILS: 'DEALER_DETAILS',
    GET_DEALER_DETAILS_REQUEST: 'GET_DEALER_DETAILS_REQUEST',
    GET_DETAILS_SUCCESS: 'GET_DETAILS_SUCCESS',
    GET_DEALER_DETAILS_FAILURE: 'DEALER_DETAILS_FAILURE',
    UPDATE_DEALER_DETAILS: 'UPDATE_DEALER_DETAILS',
    SET_DEALER_LOGO: 'SET_DEALER_LOGO',

    // Fetch Initial Config
    FETCH_INIT_CONFIG: 'FETCH_INIT_CONFIG',
    FETCH_INIT_CONFIG_REQUEST: 'FETCH_INIT_CONFIG_REQUEST',
    FETCH_INIT_CONFIG_SUCCESS: 'FETCH_INIT_CONFIG_SUCCESS',
    FETCH_INIT_CONFIG_FAILURE: 'FETCH_INIT_CONFIG_FAILURE',

    // Initial Dealer Config
    INITIAL_DEALER_CONFIG_SUCCESS: 'INITIAL_DEALER_CONFIG_SUCCESS',
    INITIAL_DEALER_CONFIG_FAILURE: 'INITIAL_DEALER_CONFIG_FAILURE',

    // Fetch DNA IDs
    FETCH_DNA_IDS: 'FETCH_DNA_IDS',
    FETCH_DNA_IDS_SUCCESS: 'FETCH_DNA_IDS_SUCCESS',
    FETCH_DNA_IDS_FAILURE: 'FETCH_DNA_IDS_FAILURE',

    // Miscellaneous
    SET_CUSTOMER_CARD_STATE: 'SET_CUSTOMER_CARD_STATE',

    // Customer
    SET_SELECTED_CUSTOMER: 'SET_SELECTED_CUSTOMER',
    VIEW_CUSTOMER_INFO: 'VIEW_CUSTOMER_INFO',
    EDIT_CUSTOMER: 'EDIT_CUSTOMER',
    UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
    CANCEL_UPDATE_CUSTOMER: 'CANCEL_UPDATE_CUSTOMER',
    UPDATE_PARTICIPANT_DETAILS: 'UPDATE_PARTICIPANT_DETAILS',
    CREDIT_CONSENT_CLICKED: 'CREDIT_CONSENT_CLICKED',

    // Cobuyer
    SET_CO_BUYER: 'SET_CO_BUYER',
    REMOVE_CO_BUYER: 'REMOVE_CO_BUYER',
    ADD_CO_BUYER: 'ADD_CO_BUYER',

    // Workflow
    UPDATE_WORKFLOW_STATE: 'UPDATE_WORKFLOW_STATE',
    UPDATE_CURRENT_DEAL: 'UPDATE_CURRENT_DEAL',
    UPDATE_CURRENT_CUSTOMER: 'UPDATE_CURRENT_CUSTOMER',

    // Deal Setup — pre-populates customer + vehicle state without triggering
    // the middleware API call (avoids the race with UPDATE_DEAL).
    PREPARE_DEAL_SETUP_STATE: 'PREPARE_DEAL_SETUP_STATE',

    //Generic Error
    GLOBAL_ERROR: 'GLOBAL_ERROR',

    // Confirmation Modal
    SHOW_CONFIRM_NAVIGATION_MODAL: 'SHOW_CONFIRM_NAVIGATION_MODAL',
    HIDE_CONFIRM_NAVIGATION_MODAL: 'HIDE_CONFIRM_NAVIGATION_MODAL',

    // CVI actions
    BUY_THIS_VEHICLE: 'BUY_THIS_VEHICLE',
    HANDLE_CANCEL_EVENT: 'HANDLE_CANCEL_EVENT',

    // Loader actions
    SHOW_GLOBAL_SPINNER: 'SHOW_GLOBAL_SPINNER',
    HIDE_GLOBAL_SPINNER: 'HIDE_GLOBAL_SPINNER',

    CHILD_COMPONENT_READY: 'CHILD_COMPONENT_READY',
    CDLV3_DATA_READY: 'CDLV3_DATA_READY',

    // Trade-In Actions
    UPDATE_TRADE_IN_CURRENT_LOCATION: 'UPDATE_TRADE_IN_CURRENT_LOCATION',
    APPLY_TRADE_IN_EQUIPMENT_OPTIONS: 'APPLY_TRADE_IN_EQUIPMENT_OPTIONS',
    OPEN_TRADE_IN: 'OPEN_TRADE_IN',
    TRADE_IN_REMOVE_SUCCESS: 'TRADE_IN_REMOVE_SUCCESS',
    TRADE_IN_UPDATE_FAILURE: 'TRADE_IN_UPDATE_FAILURE',
    TRADE_IN_UPDATE_SUCCESS: 'TRADE_IN_UPDATE_SUCCESS',
    TRADE_IN_REMOVE_FAILURE: 'TRADE_IN_REMOVE_FAILURE',
    TRADE_IN_YEARS_SUCCESS: 'TRADE_IN_YEARS_SUCCESS',
    TRADE_IN_ESTIMATE_DISPLAYED: 'TRADE_IN_ESTIMATE_DISPLAYED',

    SET_ASSUMED_DEALERSHIPS: 'SET_ASSUMED_DEALERSHIPS',

    // Credit App Actions
    CREDIT_APP_SUBMITTED: 'CREDIT_APP_SUBMITTED',

    // The action type owned by activities-credit-app
    SUBMIT_CREDIT_APP: 'SUBMIT_CREDIT_APP',

    // The action type owned by activities-request-proposal
    REQUEST_PROPOSAL_SEND_REQUEST_CLICKED: 'REQUEST_PROPOSAL_SEND_REQUEST_CLICKED',

    // Deeplink share-able link Actions
    ADD_DEEPLINK_URL: 'ADD_DEEPLINK_URL',
    ADD_DEEPLINK_URL_REQUEST: 'ADD_DEEPLINK_URL_REQUEST',
    ADD_DEEPLINK_URL_SUCCESS: 'ADD_DEEPLINK_URL_SUCCESS',
    ADD_DEEPLINK_URL_FAILURE: 'ADD_DEEPLINK_URL_FAILURE',

    // Share dropdown CDL actions
    SEND_CREDIT_APP_LINK_CDL: 'SEND_CREDIT_APP_LINK_CDL',
    SEND_DOC_UPLOAD_LINK_CDL: 'SEND_DOC_UPLOAD_LINK_CDL',
    SEND_DEAL_PDF_LINK_CDL: 'SEND_DEAL_PDF_LINK_CDL',

    SET_CUSTOMER_VEHICLES_SLIDEOUT_VISIBILITY: 'SET_CUSTOMER_VEHICLES_SLIDEOUT_VISIBILITY',

    // Duplicates of the slideout action types owned by activities-customer-vehicles (src/store/actions.ts)
    SHOW_CUSTOMER_VEHICLES_SLIDEOUT: 'SHOW_CUSTOMER_VEHICLES_SLIDEOUT',
    HIDE_CUSTOMER_VEHICLES_SLIDEOUT: 'HIDE_CUSTOMER_VEHICLES_SLIDEOUT',

    // Duplicates of the FETCH_DEALS_* action types owned by activities-customer-vehicles
    // (src/store/actions.ts) — the values must stay in sync with that activity's reducer.
    CUSTOMER_VEHICLES_FETCH_DEALS_REQUEST: 'FETCH_DEALS_REQUEST',
    CUSTOMER_VEHICLES_FETCH_DEALS_SUCCESS: 'FETCH_DEALS_SUCCESS',
    CUSTOMER_VEHICLES_FETCH_DEALS_FAILURE: 'FETCH_DEALS_FAILURE',
    OPEN_DEAL_FROM_CUSTOMER_VEHICLES: 'OPEN_DEAL_FROM_CUSTOMER_VEHICLES',
    SET_DEAL_LIST_COMPARE_ENABLED: 'SET_DEAL_LIST_COMPARE_ENABLED',
    OPEN_COMPARE_DEAL_PAGE: 'OPEN_COMPARE_DEAL_PAGE',

    // Showroom Left Nav (tablet drawer)
    SET_SHOWROOM_LEFT_NAV_OPEN: 'SET_SHOWROOM_LEFT_NAV_OPEN',
    SET_HAMBURGER_VISIBILITY: 'SET_HAMBURGER_VISIBILITY',
    SET_ACTIVE_SECTION: 'SET_ACTIVE_SECTION',
    ACTIVATE_SECTION: 'ACTIVATE_SECTION',
    BOOTSTRAP_SUCCESS: 'BOOTSTRAP_SUCCESS',
    CLOSE_TRADE_IN_MODAL: 'CLOSE_TRADE_IN_MODAL',
    CONTINUE_TO_APPLY_DEAL: 'CONTINUE_TO_APPLY_DEAL',

    // Digital Deal Jacket — deal reference ID resolution
    FETCH_DEAL_REF_ID: 'FETCH_DEAL_REF_ID',
    DDJ_OPENED: 'DDJ_OPENED',
    FETCH_DEAL_REF_ID_REQUEST: 'FETCH_DEAL_REF_ID_REQUEST',
    FETCH_DEAL_REF_ID_SUCCESS: 'FETCH_DEAL_REF_ID_SUCCESS',
    FETCH_DEAL_REF_ID_FAILURE: 'FETCH_DEAL_REF_ID_FAILURE',

    // Get Deal Actions
    GET_DEAL_DETAILS: 'GET_DEAL_DETAILS',
    FETCH_DEAL_REQUEST: 'FETCH_DEAL_REQUEST',
    FETCH_DEAL_SUCCESS: 'FETCH_DEAL_SUCCESS',
    FETCH_DEAL_FAILURE: 'FETCH_DEAL_FAILURE',

    // Deal Refresh Defer
    DEFER_DEAL_REFRESH_MODAL: 'SALES_CHECKIN/DEFER_DEAL_REFRESH_MODAL',

    // Analytics-only marker; no reducer listens to it (dc-sci-094)
    REFRESH_OFFER_UPDATES_CDL: 'REFRESH_OFFER_UPDATES_CDL',

    // Update deal summary actions
    UPDATE_DEAL_SUMMARY: 'UPDATE_DEAL_SUMMARY',
    SET_DEAL_ACCEPTED_BY_BUYER: 'SET_DEAL_ACCEPTED_BY_BUYER',

    // Duplicates of the activities-request-proposal action types — to be revisited.
    // Send to Desk performs the same save as that activity's "Send Request" button
    UPDATE_ACTIVE_DEAL_VISIBILITY_STATUS: 'UPDATE_ACTIVE_DEAL_VISIBILITY_STATUS',
    REQUEST_PROPOSAL_UPDATE_NOTES: 'REQUEST_PROPOSAL/UPDATE_NOTES',
    OPEN_REQUEST_CHANGE_MODAL: 'OPEN_REQUEST_CHANGE_MODAL',
    ACCEPT_DEAL_SUMMARY_REQUEST: 'ACCEPT_DEAL_SUMMARY_REQUEST',

    // PDF share link (Share dropdown "Deal PDF")
    FETCH_PDF_SHARE_LINK_REQUEST: 'FETCH_PDF_SHARE_LINK_REQUEST',
    FETCH_PDF_SHARE_LINK_SUCCESS: 'FETCH_PDF_SHARE_LINK_SUCCESS',
    FETCH_PDF_SHARE_LINK_FAILURE: 'FETCH_PDF_SHARE_LINK_FAILURE',

    SET_ACTIVE_DEAL_CHANGE_TYPE: 'SET_ACTIVE_DEAL_CHANGE_TYPE',

    SESSION_EXPIRED: 'SESSION_EXPIRED',

    REMOVE_TRADE_IN: 'REMOVE_TRADE_IN'
};
